export const FAVORITE_ACTION = {
  LIST: 'LIST_FAVORITES',
  CREATE: 'CREATE_FAVORITES',
  DELETE: 'DELETE_FAVORITES',
  VIEW: 'VIEW_FAVORITES',
  DELETE_ALL: 'DELETE_ALL_FAVORITES'
};